import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Ship } from 'lucide-react';
import { api } from '../lib/api';
import { RagChip, fmtDay } from '../lib/shipments';
import { hidesLinkedShipments } from '../lib/linkedShipments.mjs';

// Shipments linked to a lead or watchlist project. Renders nothing when the
// shipments module is unavailable (tables not installed yet, or no permission),
// and says so when the read fails for any other reason.
export default function ShipmentPanel({ leadId, projectId }) {
  const [rows, setRows] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    const q = leadId ? `lead_id=${leadId}` : `project_id=${projectId}`;
    setFailed(false);
    api.get(`/shipments?status=all&${q}`)
      .then((r) => { if (alive) setRows(r.shipments || []); })
      .catch((e) => {
        if (alive) {
          setRows(null);
          setFailed(!hidesLinkedShipments(e));
        }
      });
    return () => { alive = false; };
  }, [leadId, projectId]);

  if (!rows && !failed) return null;
  if (failed) {
    return (
      <div className="border-b border-[var(--border)] px-5 py-3">
        <p className="flex items-center gap-1.5 text-xs text-red-600"><Ship size={12} /> Could not load linked shipments.</p>
      </div>
    );
  }
  return (
    <div className="border-b border-[var(--border)] px-5 py-3">
      <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold text-[var(--text-secondary)]"><Ship size={12} /> Shipments ({rows.length})</p>
      {rows.length === 0 ? (
        <p className="text-xs text-[var(--text-secondary)]">None linked. Link one from <Link to="/shipments" className="text-primary hover:underline">Shipments</Link> (Edit → Linked lead / project).</p>
      ) : (
        <div className="space-y-1.5">
          {rows.map((s) => (
            <Link key={s.id} to={`/shipments/${s.id}`} className="flex items-center justify-between gap-2 rounded-lg border border-[var(--border)] bg-white px-3 py-2 hover:border-primary dark:bg-slate-900">
              <div className="min-w-0">
                <p className="truncate text-xs font-medium text-[var(--text-primary)]">{s.order_ref}</p>
                <p className="truncate text-[11px] text-[var(--text-secondary)]">{s.current_milestone_label || 'No update yet'} · need {fmtDay(s.need_by_date)}</p>
              </div>
              <RagChip schedule={s.schedule} />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
